import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import Table from "../../../core/common/dataTable/index";
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import CommonSelect from '../../../core/common/commonSelect';
import { DatePicker, Drawer, message } from 'antd';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../core/data/redux/store';
import DeleteModal1 from '../../../core/modals/deleteModal1';
import { getEmployeeByUserId, getEmployees } from '../../../core/data/redux/employee/employeeAction';
import { createOvertime, deleteOvertime, fetchAllOvertimes, fetchOvertimeByEmployeeId, fetchOvertimeSummary, updateOvertime, fetchOvertimeSummaryByEmployeeId } from '../../../core/data/redux/attendance/overtime/overtimeAction';
import { formatDate } from "../../../core/utils/configFormatters";
import dayjs from 'dayjs';
import { exportToCSV, exportToExcel, exportToPDF } from '../../../core/common/GlobalFunctions/exportTableData';
import { filterData } from '../../../core/common/GlobalFunctions/tableFilters';
import { useAppConfig } from '../../../customhooks/useAppConfig';
import { filterByStatus } from '../../../core/utils/filterActiveData';


const statusChoose = [
  { value: "1", label: "Pending" },
  { value: "2", label: "Approved" },
  { value: "3", label: "Rejected" },
];

const OverTimeAdmin = () => {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const dispatch = useDispatch<AppDispatch>();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<'edit' | 'create' | ''>('');
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { user } = useSelector((state: any) => state.auth);
  const { employees } = useSelector((state: any) => state.employee);
  const { OvertimeByEmployee, OvertimeSummary, loadingStates , overtimes } = useSelector((state: any) => state.attendance.overtime);
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
  const employeeData = employees ? employees : [];
  // const activeEmployees = filterByStatus(employees, 'active', 'employee_status');
  const [employeeId, setemployeeId] = useState<any>("");
  const [count, setcount] = useState<any>([]);
  const activeEmployeeData = filterByStatus(employeeData, 'active', 'employee_status');


  const [overtimeFormData, setOvertimeFormData] = useState({
    selectEmployeeName: employeeId || " ",
    OvertimeStatus: 1,
    Overtime: '',
    RemainingHours: '',
    Description: '',
    OvertimeDate: dayjs(),
  });
  const [formErrors, setFormErrors] = useState({
    selectEmployeeName: '',
    OvertimeStatus: '',
    Overtime: '',
    RemainingHours: '',
    Description: '',
    OvertimeDate: '',
  });



  const resetForm = () => {
    setOvertimeFormData({
      selectEmployeeName: '',
      OvertimeStatus: 1,
      Overtime: '',
      RemainingHours: '',
      Description: '',
      OvertimeDate: dayjs(),

    });
    setFormErrors({
      selectEmployeeName: '',
      OvertimeStatus: '',
      Overtime: '',
      RemainingHours: '',
      Description: '',
      OvertimeDate: '',
    })

  };

  const validateForm = () => {
    const errors: any = {};

    const overtime = parseFloat(overtimeFormData.Overtime);
    const remainingHours = parseFloat(overtimeFormData.RemainingHours);


    if (isNaN(overtime) || overtime <= 0) {
      errors.Overtime = 'Overtime is required and must be a positive number';
    }

    // if (isNaN(remainingHours) || remainingHours <= 0) {
    //   errors.RemainingHours = 'Remaining Hours is required and must be a positive number';
    // }

    if (!overtimeFormData.OvertimeDate) {
      errors.OvertimeDate = 'Overtime Date is required';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (employeeData.length === 0) {
      dispatch(getEmployees());
    }
    if (!OvertimeSummary.TotalOvertimeEmployee) {
      dispatch(fetchOvertimeSummary())
    }
  }, [OvertimeSummary.TotalOvertimeEmployee, dispatch, employeeData.length])

  //fetchOvertimeByEmployeeId

  useEffect(() => {
    if (user?.UserId) {
      dispatch(getEmployeeByUserId({ userId: user.UserId })).then((res) => {
        setemployeeId(res?.payload.data?.employeeId);
      });
    }
  }, [dispatch, user?.UserId]);


  useEffect(() => {
    if (employeeId) {
      dispatch(fetchOvertimeByEmployeeId(employeeId))
      dispatch(fetchOvertimeSummaryByEmployeeId(employeeId))
        .then((res) => {
          setcount(res.payload.data)
        })
    }
    dispatch(fetchAllOvertimes());
  }, [dispatch, employeeId])


  const showModal = (type: 'edit' | 'create') => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType('');
    resetForm();

  };

  const handleEditOvertime = (record: any): void => {
    setSelectedRowData(record);
    setOvertimeFormData({
      selectEmployeeName: record.EmployeeId,
      OvertimeStatus: record.OvertimeStatus || '',
      Overtime: record.Duration || '',
      RemainingHours: record.RemainingHours || '',
      Description: record.Description || '',
      OvertimeDate: record.OvertimeDate ? dayjs(record.OvertimeDate) : dayjs(),
    });
    showModal('edit');
  };

  const handleInputChange = (e: any, field: string) => {
    const { value } = e.target;
    setOvertimeFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    let overtimeData: any = {
      EmployeeId: overtimeFormData.selectEmployeeName,
      OvertimeStatus: Number(overtimeFormData.OvertimeStatus),
      Duration: Number(overtimeFormData.Overtime),
      RemainingHours: overtimeFormData.RemainingHours,
      Description: overtimeFormData.Description,
      OvertimeDate: overtimeFormData.OvertimeDate,
    };

    if (modalType === 'create') {
      overtimeData.CreatedBy = user?.UserId;
    } else if (modalType === 'edit') {
      overtimeData.ModifiedBy = user?.UserId;
    }

    try {
      let result;

      if (modalType === 'create') {
       const result = await dispatch(createOvertime(overtimeData))
       .then((res) => {
        if (res.meta.requestStatus === 'fulfilled') {
          message.success(res.payload.message)
          dispatch(fetchAllOvertimes());
          setTableKey((prevKey) => prevKey + 1);
          resetForm();
          handleCancel();
        }else{
          message.warning(res.payload.error)
        }
       })
      } else if (modalType === 'edit') {
        const overtimeId = selectedRowData.Id;
        const result = await dispatch(updateOvertime({ overtimeId, data: overtimeData }))
        .then((res) => {
          if (res.meta.requestStatus === 'fulfilled') {
            message.success(res.payload.message)
            dispatch(fetchAllOvertimes());
            setTableKey((prevKey) => prevKey + 1);
            resetForm();
            handleCancel();
          }else{
            message.warning(res.payload.error)
          }
        })
      }
      handleCancel();
    } catch (error: any) {
      message.error(error?.message || 'An error occurred');
    }
  };



  const handleDeleteOvertime = async (overtimeId: number) => {
    try {
      const result = await dispatch(deleteOvertime(overtimeId));
      if (result.meta.requestStatus === 'fulfilled') {
        message.success(result.payload.message);
        setIsDeleteModalVisible(false);
        await dispatch(fetchAllOvertimes());
        setTableKey((prevKey) => prevKey + 1);
      } else {
        message.warning(result.payload.error);
      }
    } catch (error) {
      message.error('Something went wrong');
    }
  };

  const data = overtimes ? overtimes : [];
  const exportOvertime = data?.map((item: any) => ({
    employeeName: item.employeeName || "N/A",
    OvertimeDate: item.OvertimeDate ? new Date(item.OvertimeDate).toLocaleDateString("en-IN") : "N/A",
    Duration: item.Duration || "0",
    OvertimeStatus: item.OvertimeStatus || "N/A",
    Description: item.Description || "N/A",
    RemainingHours: item.RemainingHours || "0",
    CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toLocaleDateString("en-IN") : "N/A",
    // CreatedBy: item.CreatedBy || "N/A",
    ModifiedAt: item.ModifiedAt ? new Date(item.ModifiedAt).toLocaleDateString("en-IN") : "N/A",
    // ModifiedBy: item.ModifiedBy || "N/A",
  }));


  const statusMapping: Record<string, number> = {
    "Pending": 1,
    "Approved": 2,
    "Rejected": 3,
  };

  let OvertimeStatus: number | null = null;
  if (selectedStatus) {
    OvertimeStatus = statusMapping[selectedStatus] !== undefined ? statusMapping[selectedStatus] : null;
  }
  const filteredData = useMemo(() => {
    return filterData(data || [], { OvertimeStatus: OvertimeStatus }, "CreatedAt", "CreatedAt", selectedSort);
  }, [data, OvertimeStatus, selectedSort, OvertimeByEmployee, overtimes]);


  useEffect(() => {
    setTableKey(prevKey => prevKey + 1);
  }, [selectedStatus, selectedSort, OvertimeByEmployee , overtimes]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Employee",
      dataIndex: "employeeName",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <Link to="#" className="avatar avatar-md border avatar-rounded">
            <img src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} className="img-fluid" alt="img" />
          </Link>
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{record.employeeName}</Link>
            </h6>
            <span className="fs-12 fw-normal ">{record.Role}</span>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Date",
      dataIndex: "OvertimeDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.OvertimeDate.length - b.OvertimeDate.length,
    },
    {
      title: "Overtime Hours",
      dataIndex: "Duration",
      sorter: (a: any, b: any) => a.Duration.length - b.Duration.length,
    },
    // {
    //   title: "Approved By",
    //   dataIndex: "Name",
    //   render: (text: String, record: any) => (
    //     <div className="d-flex align-items-center file-name-icon">
    //       <div className="ms-2">
    //         <h6 className="fw-medium">
    //           <Link to="#">Sushant</Link>
    //         </h6>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "OvertimeStatus",
      render: (text: number) => {
        let statusText = '';
        let badgeClass = '';

        switch (text) {
          case 1:
            statusText = 'Pending';
            badgeClass = 'badge-warning';
            break;
          case 2:
            statusText = 'Approved';
            badgeClass = 'badge-success';
            break;
          case 3:
            statusText = 'Rejected';
            badgeClass = 'badge-danger';
            break;
          default:
            statusText = 'Unknown';
            badgeClass = 'badge-secondary';
        }

        return (
          <span className={`badge d-inline-flex align-items-center badge-xs ${badgeClass}`}>
            <i className="ti ti-point-filled me-1" />
            {statusText}
          </span>
        );
      },
      sorter: (a: any, b: any) => a.OvertimeStatus - b.OvertimeStatus,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isApproved = record.OvertimeStatus === 2;

        return (
          <div className="action-icon d-inline-flex">
            <button
              className="me-2"
              onClick={() => { showModal('edit'); handleEditOvertime(record); }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Edit"
              disabled={isApproved}
              style={{ opacity: isApproved ? 0.5 : 1, cursor: isApproved ? "not-allowed" : "pointer" }}
            >
              <i className="ti ti-edit" />
            </button>
            <button
              onClick={() => { setSelectedRowData(record); setIsDeleteModalVisible(true); }}
              className="me-2"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Delete"
              disabled={isApproved}
              style={{ opacity: isApproved ? 0.5 : 1, cursor: isApproved ? "not-allowed" : "pointer" }}
            >
              <i className="ti ti-trash" />
            </button>
          </div>
        );
      }
    },
  ]

  const getModalContainer = () => {
    const modalElement = document.getElementById('modal-datepicker');
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Overtime Manager</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Overtime Manager
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(exportOvertime, 'overtime_data')}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(exportOvertime, 'overtime_data')}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToPDF(exportOvertime, 'overtime_data')}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as PDF{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-2">
                <button
                  onClick={() => showModal('create')}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Overtime
                </button>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Overtime Counts */}
          <div className="row">
            <div className="col custom-col-20">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5">
                        Overtime Hours
                      </p>
                      <h4>{count?.totalOvertimeHours || 0}</h4>
                    </div>
                    <div>
                      <span className="p-2 br-10 bg-pink-transparent border border-pink d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-edit text-pink fs-18" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col custom-col-20">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5">
                        Pending
                      </p>
                      <h4>{count?.totalPendingRequest || 0}</h4>
                    </div>
                    <div>
                      <span className="p-2 br-10 bg-transparent-purple border border-purple d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-exclamation text-purple fs-18" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col custom-col-20">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5">Rejected</p>
                      <h4>{count?.rejectedOvertimeRequest || 0}</h4>
                    </div>
                    <div>
                      <span className="p-2 br-10 bg-skyblue-transparent border border-skyblue d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-exclamation text-skyblue fs-18" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col custom-col-20">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5">Approved</p>
                      <h4>{count?.approvedOvertimeRequest || 0}</h4>
                    </div>
                    <div>
                      <span className="p-2 br-10 bg-skyblue-transparent border border-skyblue d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-exclamation text-skyblue fs-18" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Overtime Counts */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Overtime List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus ? selectedStatus.charAt(0).toUpperCase() + selectedStatus.slice(1) : "ALL"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Pending')}
                        className="dropdown-item rounded-1"
                      >
                        Pending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Approved')}
                        className="dropdown-item rounded-1"
                      >
                        Approved
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Rejected')}
                        className="dropdown-item rounded-1"
                      >
                        Rejected
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort ? `Sort By : ${selectedSort}` : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Recently Added")} className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Ascending")} className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Descending")} className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Last Month")} className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Last 7 Days")} className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table key={tableKey} dataSource={filteredData} columns={columns} Selection={true} />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Overtime */}
      <Drawer
        title={modalType === "edit" ? "Edit Overtime" : "Add Overtime"}
        placement="right"
        width={650}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Employee Name <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={overtimeFormData.selectEmployeeName}
                    onChange={(e) => handleInputChange(e, "selectEmployeeName")}
                  >
                    <option value="">Select Employee Name</option>
                    {[...(activeEmployeeData || [])]
                      .sort((a, b) => a.Name.localeCompare(b.Name))
                      .map((emp: any) => (
                        <option key={emp.EmployeeID} value={emp.EmployeeID}>
                          {emp.Name}
                        </option>
                      ))}
                  </select>
                  {formErrors.selectEmployeeName && (
                    <div className="text-danger">{formErrors.selectEmployeeName}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Overtime<span className="text-danger"> *</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={overtimeFormData.Overtime}
                    onChange={(e) => handleInputChange(e, 'Overtime')}
                  />
                  {formErrors.Overtime && (
                    <div className="text-danger">{formErrors.Overtime}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={overtimeFormData.OvertimeStatus}
                    onChange={(e) => handleInputChange(e, "OvertimeStatus")}
                  >
                    {Object.entries(statusMapping).map(([label, val]) => (
                      <option key={val} value={val}>
                        {label}
                      </option>
                    ))}
                  </select>
                  {formErrors.OvertimeStatus && (
                    <div className="text-danger">{formErrors.OvertimeStatus}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Remaining Hours
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={overtimeFormData.RemainingHours}
                    onChange={(e) => handleInputChange(e, 'RemainingHours')}
                  />
                  {formErrors.RemainingHours && (
                    <div className="text-danger">{formErrors.RemainingHours}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    value={overtimeFormData.Description}
                    onChange={(e) => handleInputChange(e, 'Description')}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => {
                handleCancel()
                setFormErrors({
                  selectEmployeeName: '',
                  OvertimeStatus: '',
                  Overtime: '',
                  RemainingHours: '',
                  Description: '',
                  OvertimeDate: '',
                })
              }
              }
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleFormSubmit} disabled={isLoading}>
              {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === "edit" ? "Update Overtime" : "Add Overtime"}
            </button>
          </div>
        </form>

      </Drawer>
      {/* /Add Overtime */}
      {/* Overtime Details */}
      <div className="modal fade" id="overtime_details">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title"> Overtime Details</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <div className="p-3 mb-3 br-5 bg-transparent-light">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="d-flex align-items-center file-name-icon">
                              <Link
                                to="#"
                                className="avatar avatar-md border avatar-rounded"
                              >
                                <ImageWithBasePath
                                  src="assets/img/users/user-32.jpg"
                                  className="img-fluid"
                                  alt="img"
                                />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fw-medium fs-14">
                                  <Link to="#">Anthony Lewis</Link>
                                </h6>
                                <span className="fs-12 fw-normal ">UI/UX Team</span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div>
                              <p className="fs-14 fw-normal mb-1">Hours Worked</p>
                              <h6 className="fs-14 fw-medium">32</h6>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div>
                              <p className="fs-14 fw-normal mb-1">Date</p>
                              <h6 className="fs-14 fw-medium">15 Apr 2024</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <h6 className="fs-14 fw-medium">Office Management</h6>
                      <p className="fs-12 fw-normal">
                        Worked on the Management design &amp; Development
                      </p>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Select Status <span className="text-danger"> *</span>
                      </label>
                      <CommonSelect
                        className='select'
                        options={statusChoose}
                        defaultValue={statusChoose[0]}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Overtime Details */}

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => selectedRowData?.Id && handleDeleteOvertime(selectedRowData.Id)}
      />

    </>




  )
}

export default OverTimeAdmin
